package dev.lingvo.ops.pages

import androidx.compose.runtime.Composable
import dev.lingvo.ops.components.OpsLoad
import dev.lingvo.ops.state.OpsResourcePaging
import dev.lingvo.ops.state.OpsResourceState
import dev.lingvo.shared.ops.OpsPage
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonSize
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LPagination
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun <T> OpsResourcePagination(paging: OpsResourcePaging<T>, resource: OpsResourceState<OpsPage<T>>, unit: String) =
    OpsResourcePagination(paging, resource, unit) { it }

/** Failed pages keep a real path back without describing earlier rows as the failed page's count. */
@Composable
fun <T, R> OpsResourcePagination(
    paging: OpsResourcePaging<T>,
    resource: OpsResourceState<R>,
    unit: String,
    pageOf: (R) -> OpsPage<T>,
) {
    val navigation = paging.stateFor(resource, pageOf)
    val loaded = resource.load as? OpsLoad.Ready
    if (loaded != null) {
        val page = pageOf(loaded.value)
        if (resource.refreshFailure != null) P { Text("Pagination describes the last successfully loaded result. Refresh failed.") }
        LPagination(navigation, { paging.older(page) }, paging::newer, unit = unit, loading = resource.isRefreshing)
    } else if (navigation.hasNewer) {
        if (resource.load is OpsLoad.Failed) P { Text("This page could not load. Retry it above, or return to a newer page.") }
        LButton("Return to newer $unit", paging::newer, variant = LButtonVariant.SECONDARY,
            size = LButtonSize.SM, loading = resource.load == OpsLoad.Loading)
    }
}
